/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/smartsheet" */ '@atlassian/logo-third-party/smartsheet'
		).then((m) => m.SmartsheetIcon),
	{ moduleId: '@atlassian/logo-third-party/smartsheet' },
);

const LazySmartsheetIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-smartsheet" */ './utils').then((m) => m.SmartsheetIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/smartsheet/icon' },
);

const LazySmartsheetSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-smartsheet-search-result" */ './utils').then(
			(m) => m.SmartsheetSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/smartsheet/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const SmartsheetIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazySmartsheetIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const SmartsheetSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazySmartsheetSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
